import { Type } from '@angular/core';
import { BooleanControl } from './BooleanControl';
import { ButtonGroupControl } from './ButtonGroupControl';
import { CalendarControl } from './CalendarControl';
import { DataGridControl } from './DataGridControl';
import { InputControl } from './InputControl';
import { MultiSelectControl } from './MultiSelectControl';
import { NullableBooleanControl } from './NullableBooleanControl';
import { ScriptControl } from './ScriptControl';
import { SingleSelectControl } from './SingleSelectControl';
import { SliderControl } from './SliderControl';
import { CheckboxControl } from './CheckboxControl';
import { VariableSpecificControl } from './VariableSpecificControl';
import { IVariableControl } from './_base-control';
import { LabelControl } from './LabelControl';

export const ControlMapping: { [key: string]: Type<IVariableControl> } = {
    buttongroup: ButtonGroupControl,
    grid: DataGridControl,
    numeric: SliderControl,
    input: InputControl,
    singleselect: SingleSelectControl,
    multiselect: MultiSelectControl,
    multiselectlist: MultiSelectControl,
    slider: SliderControl,
    datetime: CalendarControl,
    boolean: BooleanControl,
    nullableboolean: NullableBooleanControl,
    variablespecific: VariableSpecificControl,
    script: ScriptControl,
    checkbox: CheckboxControl,
    label: LabelControl
};
